// Định dạng ô "Bộ nhớ" của popup thông tin xe từ trường 273 trong bản tin thiết bị.
//
// Trường 273 mang dung lượng CÒN TRỐNG tính bằng MB, nhưng -1 là MÃ LỖI: thiết bị không đọc được
// bộ nhớ (df thất bại, mount hỏng). Phải tách nhánh âm ra trước khi định dạng số, nếu không màn
// hình sẽ hiện "-1 MB" — một con số vô nghĩa mà người vận hành sẽ đọc thành "gần đầy".
//
// Ba trạng thái phải phân biệt được, và không được gộp:
//   - null/undefined: thiết bị chưa gửi trường này (firmware cũ) -> "--"
//   - số âm:          thiết bị báo lỗi                            -> "Lỗi bộ nhớ"
//   - 0 trở lên:      dung lượng thật                             -> "0 MB" hoặc "11.7 GB"
//
// Riêng 0 là chỗ dễ sai nhất: cách viết cũ `value ? 'Bình thường' : '--'` coi 0 là falsy nên bộ
// nhớ đầy hoàn toàn lại hiện "--" y như thiết bị không gửi gì.
export const MEMORY_UNKNOWN = '--';
export const MEMORY_ERROR = 'Lỗi bộ nhớ';

export function formatMemoryStatus(value) {
  if (value === null || value === undefined || value === '') {
    return MEMORY_UNKNOWN;
  }

  const megabytes = Number(value);
  if (!Number.isFinite(megabytes)) {
    return MEMORY_UNKNOWN;
  }

  if (megabytes < 0) {
    return MEMORY_ERROR;
  }

  // Đổi sang GB từ mốc 1024 MB để số đọc được: 12000 MB thành "11.7 GB".
  if (megabytes >= 1024) {
    return `${(megabytes / 1024).toFixed(1)} GB`;
  }
  return `${Math.round(megabytes)} MB`;
}
